import { useTheme } from '@emotion/react';
import { Card, Grid, Typography, useMediaQuery, Button } from '@mui/material';
import {
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';
import { useCallback, useRef, useState, useEffect } from 'react';
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);
function RadarChart({ sector, interested, list }) {
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  let inspectedCount = [];
  let similarInspectedAvgCount = [];
  const [InspectedCountval, setInspectedCountval] = useState(true);
  const [SimilarInspectedAvgCountval, setSimilarInspectedAvgCountval] =
    useState(true);
  sector?.rightColumn?.map((item) => {
    inspectedCount.push(
      interested ? item?.interestedPartiesCount : item?.inspectedCount
    );
  });
  sector?.rightColumn?.map((item) => {
    similarInspectedAvgCount.push(
      interested
        ? item?.similarInterestedPartiesCount
        : item?.similarInspectedAvgCount
    );
  });

  useEffect(() => {
    list?.length > 0 &&
      list?.map((item) => {
        if (item?.dataset == 'Inspected Count') {
          if (item?.visible == true) {
            setInspectedCountval(true);
          } else {
            setInspectedCountval(false);
          }
        }
        if (item?.dataset == 'Similar Inspected Avg Count') {
          if (item?.visible == true) {
            setSimilarInspectedAvgCountval(true);
          } else {
            setSimilarInspectedAvgCountval(false);
          }
        }
      });
  }, [list]);

  const data = {
    labels: ['Week1', 'Week2', 'Week3', 'Week4', 'Week5'],
    datasets: [
      InspectedCountval && {
        label: interested ? 'Interested Parties Count' : 'Inspected Count',
        data: inspectedCount,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgb(75, 192, 192, 0.2)',
        // fontSize: matches500 ? "8px" : undefined,

        borderWidth: 1,
      },
      SimilarInspectedAvgCountval && {
        label: interested
          ? 'Similar Interested Parties Count'
          : 'Similar Inspected Avg Count',
        data: similarInspectedAvgCount,
        borderColor: 'rgb(153, 102, 255)',
        backgroundColor: 'rgb(153, 102, 255, 0.2)',
        borderWidth: 1,
        // fontSize: matches500 ? "8px" : undefined,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  const [downloadRadarChart, setDownloadRadarChart] = useState();

  let ref = useRef(null);

  const DownloadImg = useCallback(() => {
    const link = document.createElement('a');
    link.download = 'RadarChart.png';
    link.href = ref.current.toBase64Image();
    setDownloadRadarChart(ref.current.toBase64Image());
    // link.click();
  });

  useEffect(() => {
    DownloadImg();
  }, []);

  return (
    <>
      <Grid
        style={{
          display: 'flex',
          paddingTop: '5px',
          width: '100%',
          height: '100%',
        }}
      >
        <Card
          style={{
            borderRadius: '8px',
            padding: '15px',
            margin: '10px',
            flex: 1,
            boxShadow: 'none',
            minWidth: '98%',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            backgroundColor: '#ffff',
          }}
        >
          <Grid item display={'flex'} justifyContent={'left'}>
            <Typography
              sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
            >
              {' '}
              Campaign vs Market Status
            </Typography>
          </Grid>
          <Grid
            sx={{
              flex: 1,
              minHeight: 0,
              position: 'relative',
            }}
          >
            <Radar ref={ref} data={data} options={options} />
          </Grid>
        </Card>
      </Grid>
    </>
  );
}
export default RadarChart;
